import script from "./DownloadUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadUpdate.vue?vue&type=script&setup=true&lang=js"

import "./DownloadUpdate.vue?vue&type=style&index=0&id=f9eb54be&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9eb54be"]])

export default __exports__